import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { Filter, Main } from 'Containers/';
import { SC_SLP_FORM_NAME } from 'Common/FormEnum';
import { SCSLPFieldEnum as Fields } from 'Common/FieldEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';
import * as CommonStateSelectors from 'State/selectors';
import { getSitesAction } from 'State/sites/actions';
import { getFiscalYearsAction } from 'State/fiscalYears/actions';

import { SCSLPForm } from './components/SCSLPForm';

class SCSLPContainer extends Component {
  currentYear = new Date().getFullYear();

  getMainProps = () => {
    const { reportFetching } = this.props;
    return {
      toolbox: {
        formName: SC_SLP_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: reportFetching,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    const { getFiscalYearsAction } = this.props;
    getFiscalYearsAction();
  }

  handleSubmit = values => {
    const { getReport } = this.props;
    getReport('reports/SCSLPReport', values);
  };

  render() {
    const { fiscalYears, reportFetching } = this.props;
    return (
      <Fragment>
        <Filter title={'SC SLP Report'} />
        <Main {...this.getMainProps()}>
          <SCSLPForm
            loading={reportFetching}
            onSubmit={this.handleSubmit}
            fiscalYears={fiscalYears ? fiscalYears : []}
            initialValues={{
              [Fields.MealType]: 0,
              [Fields.Year]: this.currentYear,
              [Fields.Month]: 1,
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    fiscalYears: CommonStateSelectors.getFiscalYears(state),
  };
};

const mapDispatchToProps = {
  getFiscalYearsAction,
  getSitesAction,
};

SCSLPContainer = withReportSubscription(SCSLPContainer);

export const SCSLP = connect(
  mapStateToProps,
  mapDispatchToProps
)(SCSLPContainer);



// WEBPACK FOOTER //
// ./src/pages/scslp/SCSLP.js